import api from './api';

export interface Organisation {
  id: string;
  name: string;
  description: string | null;
  logoFile: string | null;
  brandingId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateOrganisationPayload {
  name: string;
  description?: string | null;
  brandingId?: string | null;
}

export type UpdateOrganisationPayload = CreateOrganisationPayload;

export const organisationsApi = {
  getAll: async (): Promise<Organisation[]> => {
    const { data } = await api.get<Organisation[]>('/organisations');
    return data;
  },

  getById: async (id: string): Promise<Organisation> => {
    const { data } = await api.get<Organisation>(`/organisations/${id}`);
    return data;
  },

  create: async (payload: CreateOrganisationPayload): Promise<Organisation> => {
    const { data } = await api.post<Organisation>('/organisations', {
      name: payload.name.trim(),
      description: payload.description?.trim() ? payload.description.trim() : null,
      brandingId: payload.brandingId ?? null,
    });
    return data;
  },

  update: async (id: string, payload: UpdateOrganisationPayload): Promise<Organisation> => {
    const { data } = await api.put<Organisation>(`/organisations/${id}`, {
      name: payload.name.trim(),
      description: payload.description?.trim() ? payload.description.trim() : null,
      brandingId: payload.brandingId ?? null,
    });
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/organisations/${id}`);
  },
};
